import { IS_TOUCH_DEVICE } from '@/constants';

export const HEADER_HEIGHT_DESKTOP = 65;
export const HEADER_HEIGHT_MOBILE = 72;

export const NOTIFICATION_HEIGHT = 40;

export const SIDEBAR_WIDTH_DESKTOP = 200;
export const SIDEBAR_WIDTH_TABLET = 165;

const PLAYER_HEIGHT_DESKTOP = 100;
const PLAYER_HEIGHT_MOBILE = 84;
export const PLAYER_HEIGHT = IS_TOUCH_DEVICE ? PLAYER_HEIGHT_MOBILE : PLAYER_HEIGHT_DESKTOP;
